import { WP_URL } from '@shared/config/env'

export interface ApplicationPayload {
  direction: string
  name: string
  company?: string
  phone: string
  email: string
  message: string
  agree: boolean
  files?: FileList | null
  /** URL of the page the form was submitted from — recorded in the notification email. */
  pageUrl: string
}

export async function submitApplication(payload: ApplicationPayload): Promise<void> {
  const formData = new FormData()
  formData.set('direction', payload.direction)
  formData.set('name', payload.name)
  formData.set('company', payload.company ?? '')
  formData.set('phone', payload.phone)
  formData.set('email', payload.email)
  formData.set('message', payload.message)
  formData.set('agree', payload.agree ? '1' : '')
  formData.set('page_url', payload.pageUrl)
  if (payload.files) {
    Array.from(payload.files).forEach(file => formData.append('documents[]', file))
  }

  const res = await fetch(`${WP_URL}/wp-json/titan/v1/application`, {
    method: 'POST',
    body: formData,
  })

  const json = await res.json().catch(() => null) as { success?: boolean; message?: string } | null

  if (!res.ok || !json?.success) {
    throw new Error(json?.message ?? `Ошибка отправки (HTTP ${res.status})`)
  }
}
